import { IAppState } from '../../common/state';

export const residentialComplexLayoutsOnSelector = (state: IAppState): boolean => {
  return state.newbuildingLayoutsOn.checked;
};
